module.exports = __webpack_public_path__ + "img/气体管路2.44258ca9.jpg";